import { isServer } from '@ulta/core/utils/device_detection/device_detection';
import { handleEmptyObjects } from '@ulta/core/utils/handleEmptyObjects/handleEmptyObjects';

/**
 * printPage onClick handler function to print the coupon
 *
 * @method printPage
 * @param {object} data
 * @returns {undefined}
 */

export const printPage = ( data ) => {
  if( !data?.divId || isServer() ){
    return;
  }

  const content = document.getElementById( data.divId );
  // 1. should not print if the provided element id not found
  if( !content ){
    return;
  }
  // 2. Grab the existing styles for the body and printed div id
  // 3. Adding an event listener to reset the styles to the original styles
  const handleAfterPrint = ()=>{
    // remove the afterprint listener after print. so it does trigger multiple after print callback
    global.removeEventListener( 'afterprint', handleAfterPrint );
    printStyler( {
      id: data.divId,
      bodyReset: document.body.style,
      divReset: document.getElementById( data.divId ).style
    } );
  };
  global.addEventListener( 'afterprint', handleAfterPrint );

  // 4. Call the style function to update the page
  printStyler( { id: data.divId, type: 'print' } );

  // 5. Call the window/global print function
  global.print();

};

export const printStyler = ( data ) => {
  const {
    id,
    type,
    divReset = '',
    bodyReset = ''
  } = handleEmptyObjects( data );

  if( isServer() ){
    // to prevent any SSR code from trying to render this if used outside printPage util
    return;
  }

  const content = document.getElementById( id );

  if( type === 'print' ){
    // if we're printing, hide everything
    document.body.style = 'visibility:hidden';
    // only show the div we want to print
    content.style = 'visibility:visible; position:absolute; top:0; left:0';
  }
  else {
    // Reset the body and div when we're not printing
    document.body.style = bodyReset;
    content.style = divReset;
  }
};